export const restructureData = (data, key) => {
  const result = {};

  Object.keys(data).forEach((key) => {
    if (typeof data[key] === "object" && data[key].fieldName) {
      const fieldName = data[key].fieldName;
      result[fieldName] = data[key].rows;
    }
  });
  return result;
};
